<div class="brand">
    <img [src]="imageUrl" [alt]="alt" />
</div>
